"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ObjectEntries = void 0;

var ObjectEntries = Object.entries || function (obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
};

exports.ObjectEntries = ObjectEntries;